import { QrReader } from 'BreetComponents';
import { useCallback } from 'react';

import type { IScanWalletAddressProps } from './WalletAddresses.helpers';

const ScanWalletAddress = ({ handleClose, validateAddress }: IScanWalletAddressProps) => {
	const handleScannedAddress = useCallback(
		async (address: string) => {
			await validateAddress(address);
			handleClose();
		},
		[validateAddress, handleClose]
	);

	return (
		<div className='scanwalletaddress'>
			<QrReader
				setAddress={handleScannedAddress}
				onClose={handleClose}
			/>
		</div>
	);
};

export default ScanWalletAddress;
